import { useCallback, useContext, useMemo, useState } from 'react';
import { GlobalStateDataContext } from '../../../context-api/data-provider/GlobalStateDataProvider';
import {
  apiOrdersToTrackingOrders,
  countInHouseStatusTabCounts,
  filterInHouseTrackingOrders,
} from './mapOrderTrackingModel';

export function useInHouseDeliveryOrders() {
  const { inHouseDeliveryOrders } = useContext(GlobalStateDataContext);

  const [statusFilter, setStatusFilter] = useState('all');
  const [orderIdSearch, setOrderIdSearch] = useState('');
  const [deliveryTypeFilter] = useState('all');

  const allOrders = useMemo(
    () => apiOrdersToTrackingOrders(inHouseDeliveryOrders ?? []),
    [inHouseDeliveryOrders]
  );

  const totalCount = allOrders.length;

  const filteredOrders = useMemo(
    () =>
      filterInHouseTrackingOrders(allOrders, {
        statusFilter,
        deliveryTypeFilter,
        orderIdSearch,
      }),
    [allOrders, statusFilter, deliveryTypeFilter, orderIdSearch]
  );

  const tabCounts = useMemo(() => countInHouseStatusTabCounts(allOrders), [allOrders]);

  const refresh = useCallback(() => {}, []);

  return {
    loading: false,
    totalCount,
    loadError: null,
    lastRefreshAt: null,
    statusFilter,
    setStatusFilter,
    orderIdSearch,
    setOrderIdSearch,
    deliveryTypeFilter,
    filteredOrders,
    tabCounts,
    refresh,
  };
}
